// extracted by mini-css-extract-plugin
export default {"card":"card_card__XoCn7","cardImg":"card_cardImg__GA8X7"};